import * as R from 'ramda'

export const getInitState = skillsArray =>
  R.addIndex(R.reduce)(
    (acc, key, index) => ({ ...acc, [key]: index < 2 }),
    {},
    skillsArray,
  )

export const getToggledState = (skillsArray, allReviewsOpen) =>
  R.reduce((acc, key) => ({ ...acc, [key]: !allReviewsOpen }), {}, skillsArray)
